import { APICallV3Post } from 'reactApp/api/APICall';

export class AllDocumentsAccessRequestAPICallV4 extends APICallV3Post {
    _method = '/cloud/subscription';
}
